import { useState, useEffect } from "react";
import { guessTextLanguage } from "utils/misc";

export default function useTextLanguage(text) {
  const [language, setLanguage] = useState(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLanguage(guessTextLanguage(text));
    }, 500);

    return () => clearTimeout(timeout);
  }, [text]);

  return language;
}
